import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SelectboxforJobCategory from "../../../../components/Utils/Selectbox/SelectboxforJobCategory";
import { Colors } from "../../../../theme/colors";
import { useAppSelector } from "../../../../redux/hooks";

interface JobCategorySelectProps {
  mainJobCategoryValue: string | null;
  subJobCategoryValue: string | null;
  anchorElOpenMainCategory: HTMLElement | null;
  anchorElOpenSubCategory: HTMLElement | null;
  handleClickMainCategory: (
    e: React.MouseEvent<HTMLDivElement>,
    type: "MainCategory" | "SubCategory"
  ) => void;
  handleCloseMainCategory: (type: "MainCategory" | "SubCategory") => void;
  setSelectionBoxValue: any;
}

const JobCategorySelect: React.FC<JobCategorySelectProps> = ({
  mainJobCategoryValue,
  subJobCategoryValue,
  anchorElOpenMainCategory,
  anchorElOpenSubCategory,
  handleClickMainCategory,
  handleCloseMainCategory,
  setSelectionBoxValue,
}) => {

  const { mainJobCategory, subJobCategory } = useAppSelector(
    (state) => state.campaigns
  );

  const [mainCategoryArr, setMainCategoryArr] = useState<any>([]);
  const [subCategoryArr, setSubCategoryArr] = useState<any>([]);


  useEffect(() => {
    var array: any = [];
    mainJobCategory?.map((ab: any, index: number) => {
      return array.push(ab);
    });
    setMainCategoryArr(array);
  }, [mainJobCategory]);


  useEffect(() => {
    var array: any = [];
    subJobCategory?.map((ab: any, index: number) => {
      return array.push(ab);
    });
    setSubCategoryArr(array);
  }, [subJobCategory]);

  return (
    <Box
      sx={{
        marginTop: "20px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
        <Box sx={{ width: "50%" }}>
          <Typography
            color={Colors.black}
            fontSize={"14px"}
            variant="h6"
          >
            Main Category
          </Typography>
          <SelectboxforJobCategory
            handleClick={(e) => handleClickMainCategory(e, "MainCategory")}
            handleClose={() => handleCloseMainCategory("MainCategory")}
            changeBoxValue={(val, id) =>
              setSelectionBoxValue(val, "MainCategory", id)
            }
            open={Boolean(anchorElOpenMainCategory)}
            anchorEl={anchorElOpenMainCategory}
            isCreatePage={true}
            title={mainJobCategoryValue || "Main Category"}
            menuOption={mainCategoryArr}
            name="MainCategory"
          />
        </Box>

        <Box sx={{ width: "50%" }}>
          <Typography
            color={Colors.black}
            fontSize={"14px"}
            variant="h6"
          >
            Sub Category
          </Typography>
          <SelectboxforJobCategory
            handleClick={(e) => handleClickMainCategory(e, "SubCategory")}
            handleClose={() => handleCloseMainCategory("SubCategory")}
            changeBoxValue={(val, id) =>
              setSelectionBoxValue(val, "SubCategory", id)
            }
            open={Boolean(anchorElOpenSubCategory)}
            anchorEl={anchorElOpenSubCategory}
            isCreatePage={true}
            title={subJobCategoryValue || "Sub Category"}
            menuOption={subCategoryArr}
            name="SubCategory"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default JobCategorySelect;
